export default {
  title: 'Yrityksen varauspalvelu on poistettu käytöstä',
  description:
    'Varauspalvelu ei ole tällä hetkellä käytössä tälle yritykselle. Voit ottaa sen käyttöön kohdassa Palvelut.',
  button: {
    settings: 'Siirry asetuksiin',
  },
};
